import has from 'lodash/has'

import { ModalOpenActions } from '../../types/sideActions/modalOpenActions'

export const isActionModal = (modalActions: ModalOpenActions, actionId: keyof ModalOpenActions) =>
  has(modalActions, actionId) && typeof modalActions[actionId] === 'function'
